import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 * Issued under the Academic Public License.
 *
 * You can be released from the terms, and requirements of the Academic Public
 * License by purchasing a commercial license.
 * Purchase of a commercial license is mandatory for any use of the
 * LMX Software in commercial settings.
 */
// END COPYRIGHT
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import logger from "./logger";
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root container missing");
}
const root = ReactDOM.createRoot(container);
// Small startup log to demonstrate client-side logger in DevTools
logger.info("LMX React UI starting");
root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
